module.exports = __webpack_public_path__ + "static/media/csm-love-home.586e97b4.svg";